import React from 'react';

export const GREEN_LINE = 'Green Line';
export const BLUE_LINE = 'Blue Line';
export const SOUTH_LINE = 'Suðurleið';
export const NORTH_LINE = 'Norðurleið';
export const SHORE_LINE = 'Strandleið';

export default class ColorLine extends React.Component {
  getColorCssClass(description) {
    switch (description) {
      case GREEN_LINE:
        return 'green';
      case BLUE_LINE:
        return 'blue';
      case SOUTH_LINE:
        return 'cyan';
      case NORTH_LINE:
        return 'red';
      case SHORE_LINE:
        return 'green';
      default:
        return 'neutral';
    }
  }

  renderMapButton = () => (
    <button
      className="mapButton"
      onClick={() => {
        this.props.onOpenMap(this.props.description);
      }}
    >
      View map
    </button>
  );

  render() {
    const lineType = ['colorLine'];
    lineType.push(this.getColorCssClass(this.props.description));

    return this.props.description ? (
      <div className="colorLineAndMap">
        <span className={lineType.join(' ')}>{this.props.description}</span>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/colorLine.js